import { DOOH_DIMENSION_ALLOWLIST } from 'common/constants/dimensions';

function getDimensionValue(dimension) {
    return dimension && (dimension.value || dimension.name);
}

function getCampaignDimensionAllowlist(campaign) {
    const campaignType = campaign && campaign.campaign_type;

    const allowlistByCampaignType = {
        dooh: DOOH_DIMENSION_ALLOWLIST,
    };

    return allowlistByCampaignType[campaignType] || null;
}

export function isDoohCampaign(campaign) {
    return !!(campaign && campaign.campaign_type === 'dooh');
}

export function filterDimensionTreeForCampaign(dimensions, campaign) {
    const allowlist = getCampaignDimensionAllowlist(campaign);
    if (!allowlist) {
        return dimensions;
    }

    return (dimensions || [])
        .map(dimension => {
            const children = (dimension.children || []).filter(child =>
                allowlist.includes(getDimensionValue(child))
            );

            return {
                ...dimension,
                children,
            };
        })
        .filter(dimension => {
            const value = getDimensionValue(dimension);
            return (
                allowlist.includes(value) || (dimension.children && dimension.children.length > 0)
            );
        });
}

export function sanitizeSelectedDimensionsForCampaign(selectedDimensions, campaign) {
    const allowlist = getCampaignDimensionAllowlist(campaign);
    if (!allowlist) {
        return selectedDimensions;
    }

    return (selectedDimensions || []).filter(dimensionName => allowlist.includes(dimensionName));
}

export function sanitizeDimensionMatchForCampaign(dimensionMatch, campaign) {
    const cleanedDimensionMatch = dimensionMatch || {};

    const allowlist = getCampaignDimensionAllowlist(campaign);
    if (!allowlist) {
        return cleanedDimensionMatch;
    }

    return Object.keys(cleanedDimensionMatch).reduce((acc, key) => {
        if (allowlist.includes(key)) {
            acc[key] = cleanedDimensionMatch[key];
        }
        return acc;
    }, {});
}
